export default "__VITE_ASSET__DMEofxON__"